import { Enum, EnumType } from 'ts-jenum';
import _ from 'lodash';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faCheck, faClipboardList, faEdit } from '@fortawesome/pro-solid-svg-icons';

@Enum<CallProgressState>('value')
export class CallProgressState extends EnumType<CallProgressState>() {
   static readonly TODO = new CallProgressState('TODO', 0, 'samwin.types.call_progress_state.todo', 'progress-state-is-todo', faClipboardList);
   static readonly IN_PROGRESS = new CallProgressState('IN_PROGRESS', 1, 'samwin.types.call_progress_state.in_progress', 'progress-state-in-progress', faEdit);
   static readonly DONE = new CallProgressState('DONE', 2, 'samwin.types.call_progress_state.done', 'progress-state-is-done', faCheck);

   private constructor(
      public value: string,
      public samwinValue: number,
      public translationKey: string,
      public styleClass: string,
      public icon: IconDefinition
   ) {
      super();
   }

   public static valueBySamwinValue(samwinValue: number): CallProgressState {
      const state = _(CallProgressState.values())
         .filter((x) => x.samwinValue === samwinValue)
         .first();
      if (_.isNil(state)) {
         return CallProgressState.IN_PROGRESS;
      }
      return state;
   }
}
